import type {
    IsoAndUnixTimestamp} from "@@/shared/date-time/iso-and-unix";
import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { idZodSchema } from "@@/shared/id";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { OrderId} from "../order-id";
import { orderIdZodSchema } from "../order-id";

type OrdersResendMailCommand = {
    readonly _id: string;
    readonly _type: "ORDERS_RESEND_MAIL_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;
    readonly orders: OrderId[];

    readonly mailType: "CONFIRMATION"; //Only confirmation mail is supported for now
};

type FactoryParams = Except<
    OrdersResendMailCommand,
    "_id" | "_type" | "_createdAt"
>;
const ordersResendMailCommandFactory = (params: FactoryParams) => {
    const ordersFulfilled: OrdersResendMailCommand = {
        ...params,
        _id: generateId({ prefix: "order_resend_command__" }),
        _type: "ORDERS_RESEND_MAIL_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return ordersFulfilled;
};

const ordersResendMailCommandZodSchema: z.ZodSchema<OrdersResendMailCommand> =
    z.object({
        _id: idZodSchema,
        _type: z.literal("ORDERS_RESEND_MAIL_COMMAND"),
        _createdAt: isoAndUnixZodSchema,
        orders: z.array(orderIdZodSchema),
        mailType: z.literal("CONFIRMATION"),
    });

export { ordersResendMailCommandFactory, ordersResendMailCommandZodSchema };
export type {
    OrdersResendMailCommand,
    FactoryParams as OrdersResendMailCommandFactoryParams,
};
